import { User } from 'containers/user/types/user'

export interface ProfileStore {
  profile?: User
  setProfile: (profile: User) => void
}

export enum ProfileRelationType {
  CONNECTION = 'connection',
  CONNECTION_REQUESTED = 'connection_requested',
  CONNECTION_RECEIVED = 'connection_received',
  NONE = 'none',
  OWN_PROFILE = 'own_profile',
  BLOCKED = 'blocked',
}
